import { UseMutationOptions, useMutation } from "@tanstack/react-query";
import { FieldValues } from "react-hook-form";
import axiosAuth from "../../axiosAuth";
import { INVENTORY_SETUP } from "../apiRoutes";

const mutateUpdateInventorySetup = async ({ id,data }: { id:string; data: FieldValues }) => {
  return await axiosAuth.put(`${INVENTORY_SETUP}${id}`, data);
};

const useUpdateInventorySetupsMutation = (
  queryParams?: UseMutationOptions<
    any,
    Error,
    {
      id: string;
      data: FieldValues;
    },
    unknown
  >
) =>
  useMutation({
    mutationFn: mutateUpdateInventorySetup,
    ...queryParams,
  });

export default useUpdateInventorySetupsMutation;
